// 학교명 표기 차이를 하나로 정규화 — "개림중"과 "개림중학교"를 같은 학교로 인식시킨다.

/**
 * 학교명을 canonical 형태로 정규화한다.
 * 축약 접미사를 정식 명칭으로 확장: 초→초등학교, 중→중학교, 고→고등학교.
 * 예: "개림중" → "개림중학교", "동래고" → "동래고등학교", "개림중학교" → "개림중학교"(유지).
 * 그룹핑·담당 매칭의 '키'로만 쓰고, 화면 표시에도 이 값을 쓰면 표기가 일관된다.
 */
export function normalizeSchool(school?: string): string {
  const s = (school || "").replace(/\s+/g, "").trim();
  if (!s) return "";
  if (/(초등학교|중학교|고등학교|학교)$/.test(s)) return s;
  if (/초$/.test(s)) return s.replace(/초$/, "초등학교");
  if (/중$/.test(s)) return s.replace(/중$/, "중학교");
  if (/고$/.test(s)) return s.replace(/고$/, "고등학교");
  return s;
}

/** 두 학교명이 표기 차이를 무시하고 같은 학교인가. */
export function sameSchool(a?: string, b?: string): boolean {
  return normalizeSchool(a) === normalizeSchool(b) && normalizeSchool(a) !== "";
}
